import React from 'react'
import {MdKeyboardArrowDown as DownIcon, MdShoppingBasket as CartIcon} from 'react-icons/md'
import Loading from '@components/Loading'
import sleep from '@helpers/misc/sleep'
import formatNumber from '@i18n/formatNumber'
import {TFunction, withTranslation} from 'next-i18next'

import styles from './styles.module.css'

export interface CartMenuProps {
  open: boolean
  onClick: any
  cart: {
    totalPrice?: number
    itemsPrice?: number
  }
  tableName: string
  deliveryType: string
  t: TFunction
}

export class CartMenu extends React.Component<CartMenuProps> {
  state = {className: '', showMessage: 'close'}

  componentDidUpdate(prevProps, prevState) {
    const {cart} = this.props
    const {cart: prevCart} = prevProps
    if (!prevCart) return // First load, skip animation

    const total = (cart && cart.totalPrice) || 0
    const prevTotal = (prevCart && prevCart.totalPrice) || 0
    if (total > prevTotal) {
      this.attention()
    }

    if (!prevTotal && total) {
      this.showMessage()
    }
  }

  async attention() {
    this.setState({className: 'animated shake'})
    await sleep(1000)
    this.setState({className: 'animated'})
  }

  async showMessage() {
    this.setState({showMessage: 'show'})
    await sleep(3000)
    this.setState({showMessage: 'hide'})
    await sleep(1000)
    this.setState({showMessage: 'close'})
  }

  renderLabelExtra() {
    if (this.props.deliveryType !== 'serve') return
    if (!this.props.tableName) return
    return `, Mesa ${this.props.tableName}`
  }

  renderTotal({cart, total}) {
    if (cart) {
      return formatNumber(total, 'money')
    }

    return <Loading />
  }

  renderCartIcon() {
    if (this.props.tableName) return null

    return (
      <div className={styles.cartIcon}>
        <CartIcon size={20} aria-label="cart" />
      </div>
    )
  }

  render() {
    const {open, onClick, cart} = this.props
    const total = (cart && cart.itemsPrice) || 0
    if (open) {
      return (
        <div className={styles.cartMenuClose} onClick={onClick}>
          Cerrar
        </div>
      )
    }

    const openClassName = total > 0 ? styles.cartHightlightMobile : ''

    return (
      <div className={openClassName + ' ' + styles.cartMenuOpen} onClick={onClick}>
        <div>
          {this.props.t('order.cart.cartMenu.labelMyOrder', {name: this.renderLabelExtra()})}
        </div>
        {this.props.tableName ? null : (
          <div className={styles.icon}>
            <DownIcon size={22} />
          </div>
        )}
        <div className={styles.divider} />
        <div className={styles.cart}>
          <div className={styles.total + ' ' + this.state.className}>
            {this.renderTotal({cart, total})}
          </div>
          {this.renderCartIcon()}
        </div>
        {this.state.showMessage !== 'close' ? (
          <div className={this.state.showMessage === 'show' ? styles.message : styles.messageHide}>
            <div className={styles.arrowWrapper}>
              <div className={styles.arrowUp} />
            </div>
            {this.props.t('order.titleOrderContinue')}
          </div>
        ) : null}
      </div>
    )
  }
}

export default withTranslation()(CartMenu)
